import { accountContactApi } from './contact';

export * from './contact/useAccountContact';

export const accountApi = {
  contact: accountContactApi,
};
